const site = require('../data/site.json');

module.exports = {
  title: site.name,
  description: 'Texas Fortress AI turns ideas into shipped code—quickly and securely.',
  keywords: 'texas fortress ai, software development, docker, coolify, automation',
  url: 'https://texasfortress.ai',
  twitter: '@texasfortressai',
  seoImage: 'https://texasfortress.ai/images/fire-from-sky.png',
  color: '#000000'
};
